import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {DateSelectorRange, DeleteModal, Loader, PageLoader, SelectMain, SimpleTabs} from "components";
import {AddNotes, History, MainDetails, Notes} from "fragments";
import {patientDetails, PatientTypesList} from "./constants";
import {FindLoad, useDetailModal, useModal, usePrimaryModal} from "utils";
import {patientsActions} from "store";
import {Svg} from "assets";
import {AddPatient, PatientTrips} from "./fragments";

const tabsLabels = [{label: "Details"}, {label: "Notes"}, {label: "Trips"}, {label: "History"}];

const ACTION_TYPE = "GET_SINGLE_PATIENT";
const ACTION_DELETE = "DELETE_PATIENT";

export const PatientSingle = ({item, afterSuccess}) => {
    const [tripFilters, setTripFilters] = useState({});
    const loading = FindLoad(ACTION_TYPE);
    const {notesList} = useSelector((state) => ({
        notesList: state.notes.notesList,
    }));
    const singlePatient = useSelector((state) => state.patients.singlePatient);
    const {control, watch, setValue} = useForm();
    const dispatch = useDispatch();
    const {closeDetail} = useDetailModal();
    const {openModal, close} = useModal();
    const {openPrimary, closePrimary} = usePrimaryModal();

    const patientId = item?._id || item?.id;

    useEffect(() => {
        if (patientId) {
            dispatch(patientsActions.getSinglePatient(patientId));
        }
        return () => {
            dispatch({type: 'GET_SINGLE_PATIENT_SUCCESS', payload: null});
        };
    }, [patientId]);

    useEffect(() => {
        if (singlePatient?.status) {
            setValue('status', singlePatient?.status)
        }
    }, [singlePatient?.status]);

    const handleGetDates = (dates) => {
        setTripFilters(dates);
    }

    const payerDetailsTabContent = [
        {
            tabComponent: <MainDetails info={patientDetails(singlePatient)}/>,
            tab: "Details",
        },

        {
            tabComponent: <Notes currentId={patientId} onResource="patient"/>,
            tab: "Notes",
        },

        {
            tabComponent: <PatientTrips currentId={patientId} filters={tripFilters}/>,
            tab: "Trips",
        },

        {
            tabComponent: <History
                currentId={patientId}
                notDescText="No changes have been recorded for this patient yet."
            />,
            tab: "History",
        },
    ];

    const changeStatus = (status) => {
        dispatch(patientsActions.changeStatus(patientId, {status}))
    }

    const addPatient = () => {
        openModal(
            <AddPatient
                info={singlePatient}
                afterSuccess={() => {
                    dispatch(patientsActions.getSinglePatient(patientId, true));
                    closePrimary();
                    afterSuccess?.()
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 756
            });
    };

    const handleDelete = () => {
        openPrimary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(patientsActions.deletePatient(patientId));
                }}
                handleCancel={closePrimary}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${singlePatient?.firstName} ?`}
                afterSuccess={() => {
                    closeDetail();
                    closePrimary();
                    afterSuccess?.()
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleAddNote = () => {
        openPrimary(<AddNotes onResource="patient" currentId={patientId}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1276
        });
    };

    const handelTextButton = (currentTab) => {
        return currentTab === "Notes" && notesList?.length ? "Add Note" : "";
    };

    const handleAdd = (currentNote) => {
        return currentNote === "Notes" && handleAddNote;
    };

    return (
        <div className="patients-single-wrapper">
            {!!loading?.length
                ? <PageLoader/>
                :
                <>
                    <div className="modal-header-main">
                        <h2 className="modal-header-title">{singlePatient?.firstName}</h2>

                        <div className="align-center" style={{gap: 8}}>
                            <div style={{minWidth: 145}}>
                                <SelectMain
                                    list={PatientTypesList}
                                    renderLabel={(option) => option.name}
                                    name='status'
                                    control={control}
                                    placeholder="Status"
                                    selectedValue={'id'}
                                    allowError={false}
                                    disableClearable
                                    handleChange={changeStatus}
                                />
                            </div>

                            <button
                                className="reset-btn" onClick={addPatient}
                                style={{padding: 8}}
                            >
                                <Svg.EditInfoSvg
                                    style={{filter: 'brightness(0) saturate(100%) invert(13%) sepia(57%) saturate(742%) hue-rotate(177deg) brightness(95%) contrast(93%)'}}
                                />
                            </button>

                            <button
                                className="reset-btn"
                                onClick={handleDelete}
                                style={{padding: 8}}
                            >
                                <Svg.TrashSvg/>
                            </button>

                            <button
                                className="modal-close-btn-main"
                                type="button"
                                onClick={closeDetail}
                            >
                                <Svg.CloseSvg/>
                            </button>
                        </div>
                    </div>

                    <div className="modal-body-main" style={{maxHeight: '70vh'}}>
                        <SimpleTabs
                            tabsLabels={tabsLabels}
                            tabsContent={payerDetailsTabContent}
                            defaultTab="Details"
                            pushToHistory={false}
                            handelTextButton={handelTextButton}
                            handleAdd={handleAdd}
                            headerComponent={(value) => (value === 'Trips' &&
                                <DateSelectorRange
                                    startName={'from'}
                                    endName={'to'}
                                    handleGetDates={handleGetDates}
                                />
                            )}
                        />
                    </div>
                </>
            }
        </div>
    );
};
